<template>
  <div>
    <t-loading v-model="loading" />
    <div class="pt-4 px-4">
      <v-row class="justify-space-between mb-2 mt-6">
        <v-col cols="12" md="10" class="d-flex">
          <v-btn icon color="primary" :to="{ name: 'orders' }" exact>
            <v-icon left medium>mdi-arrow-left</v-icon>
          </v-btn>
          <p style="color: #4477ad; font-size: 26px">
            {{ $t("order") + " " + (getData.SALES_ORDER || "") }}
          </p>
        </v-col>
      </v-row>
      <v-card class="pa-6">
        <v-row style="width: 95%" class="ma-auto">
          <v-col cols="12" md="4">
            <header-details-row
              :label="$t('customer')"
              :data="getData.CUSTOMER"
            />
          </v-col>
          <v-col cols="12" md="4">
            <header-details-row
              :label="$t('paymentTerm')"
              :data="getData.PAYMENT_TERM"
            />
          </v-col>
          <v-col cols="12" md="4">
            <header-details-row :label="$t('orderType')" :data="getData.TYPE" />
          </v-col>

          <v-col cols="12" md="4">
            <header-details-row
              :label="$t('purchaseOrder')"
              :data="getData.CUSTOMER_PO"
              :data-text-class="[
                'font-weight-bold',
                'pt-0',
                'text-md-subtitle-1',
                'red--text',
                'text--lighten-1',
              ]"
            />
          </v-col>
          <v-col cols="12" md="4" v-if="validateCountryInfo()">
            <header-details-row
              :label="$t('deliveryLocation')"
              :data="[
                getData.SHIPPING_INSTRUCTIONS,
                getData.CITY,
                getData.STATE,
              ]"
            />
          </v-col>
          <v-col cols="12" md="4" v-else>
            <header-details-row
              :label="$t('deliveryLocation')"
              :data="[getData.SHIP_TO, getData.CITY, getData.STATE]"
            />
          </v-col>
          <v-col cols="12" md="4">
            <header-details-row
              :label="$t('seller')"
              :data="getData.SALESREP_NAME"
            />
          </v-col>

          <v-col cols="12" md="4">
            <header-details-row
              :label="$t('createdDate')"
              :data="getData.ORDER_DATE"
            />
          </v-col>
          <v-col cols="12" md="4">
            <header-details-row :label="$t('status')">
              <data-table-chip-status
                :statusDetail="getData.STATUS_PEDIDO"
                :value="Object.assign([], getData.ITENS_QTD || '')"
              />
            </header-details-row>
          </v-col>
          <v-col cols="12" md="4">
            <header-details-row>
              <data-table-currency-column
                :before="$t('subtotal') + ': '"
                :value="getData.SUBTOTAL_CLOSED"
                :options="{ prefix: '$USD', decimals: VUE_APP_DECIMALS }"
              />
              <data-table-currency-column
                :before="$t('taxes') + ': '"
                :value="getData.TAXES_CLOSED"
                :options="{ prefix: '$USD', decimals: VUE_APP_DECIMALS }"
              />
              <data-table-currency-column
                :before="$t('total') + ': '"
                :value="getData.TOTAL_CLOSED"
                :options="{ prefix: '$USD', decimals: VUE_APP_DECIMALS }"
              />
            </header-details-row>
          </v-col>
          <v-col v-if="canShowPending()" cols="12" md="4">
            <header-details-row :label="$t('pendiente')">
              <ul>
                <li v-for="item in pendingReason" :key="item">{{ item }}</li>
              </ul>
            </header-details-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="mt-8">
        <list-order-items-component
          class="pa-0 reset-listview"
          :details="getDetailsList"
        />
      </v-card>
    </div>
  </div>
</template>

<script>
import ListOrderItemsComponent from "./components/ListOrderItemsComponent.vue";
import DataTableChipStatus from "./components/DataTableChipStatus.vue";
import { mapState, mapActions } from "vuex";
import DataTableCurrencyColumn from "../../arch/components/data-table/columns/DataTableCurrencyColumn.vue";
import HeaderDetailsRow from "@/arch/components/HeaderDetailsRow.vue";
import { VUE_APP_DECIMALS, VUE_APP_COUNTRY } from "@/config";

export default {
  name: "ViewOrderDetails",
  components: {
    ListOrderItemsComponent,
    DataTableChipStatus,
    DataTableCurrencyColumn,
    HeaderDetailsRow,
  },
  props: {
    parent: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      details: [],
    };
  },
  async mounted() {
    await this.getBillingData();
  },
  methods: {
    async getBillingData() {
      this.loading = true;

      await this.setDetailsDataToList(
        this.getData.SALES_ORDER || this.$route.params.id
      );

      this.loading = false;
    },
    canShowPending() {
      let status = (this.getData.STATUS_HEADER || "").toLowerCase();

      return (
        this.pendingReason &&
        status &&
        !["cerrado", "cancelado"].includes(status)
      );
    },
    emptyString(string) {
      return string ? string.trim() || " - " : " - ";
    },
    ...mapActions({
      setDetailsDataToList(dispatch, payload) {
        return dispatch("ordersStore/setDetailsDataToList", payload);
      },
    }),
    validateCountryInfo() {
      if (VUE_APP_COUNTRY == "EC") {
        return true;
      }
    },
  },
  computed: {
    ...mapState({
      getData(_, getters) {
        return getters["ordersStore/getData"];
      },
      getDetailsList(_, getters) {
        return getters["ordersStore/getDetailsList"];
      },
    }),
    pendingReason() {
      const pending = this.getData.HOLD_NAME;

      if (!pending) {
        return null;
      }

      return [...new Set(pending.split(","))];
    },
    VUE_APP_DECIMALS() {
      return VUE_APP_DECIMALS;
    },
  },
};
</script>
